import { render } from "./TableColumn.vue?vue&type=template&id=2c3afbf8"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c3afbf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c3afbf8', __exports__)) {
    api.reload('2c3afbf8', __exports__)
  }
  
  module.hot.accept("./TableColumn.vue?vue&type=template&id=2c3afbf8", () => {
    api.rerender('2c3afbf8', render)
  })

}


export default __exports__